export default "/img/LY.311bf26106ad95c92812969cdcc226cc.png";